import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

import { formatRelativeDateTime } from '@motorway/mw-dealer-shared-components/utils';

import { useInterval } from 'Utilities/hooks/hooks';

const getIntervalFrequency = (value) => {
	if (dayjs().diff(value, 'hour')) {
		return 300000; // update every 5 minutes
	}

	return 10000; // update every 10 seconds
};

const BidCreatedAtTimer = ({ value }) => {
	const [{ fromNow, isDynamic }, setState] = useState(formatRelativeDateTime(value));

	const updater = useCallback(() => {
		setState(formatRelativeDateTime(value));
	}, [value]);

	useInterval(updater, getIntervalFrequency(value), { runInterval: isDynamic });

	return <>{fromNow}</>;
};

BidCreatedAtTimer.propTypes = {
	value: PropTypes.string.isRequired,
};

export default BidCreatedAtTimer;
